var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-bg",style:(_vm.bgStyle)},[_c('button',{staticClass:"back-button",on:{"click":_vm.goBack}}),_c('div',{staticClass:"mapContiner"},[_c('echarts')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }